/* eslint-disable react/sort-comp */
import React from 'react'

const ACTIONS = {
  CANCEL: 'cancel',
  SUBMIT: 'submit',
  SUCCESS: 'success',
}

const withHooks = WrappedComponent =>
  class ComponentWithHooks extends React.PureComponent {
    constructor(props) {
      super(props)

      this.state = this.initStateWithHooks()
    }

    getHooksGroupName = action => `${action}Hooks`

    initStateWithHooks = (state = {}) => {
      Object.values(ACTIONS).forEach(action => {
        const hooksGroup = this.getHooksGroupName(action)
        state[hooksGroup] = []
      })

      return state
    }

    addHookOn = action => hookFunc => {
      const hooksGroup = this.getHooksGroupName(action)
      this.setState(state => ({
        ...state,
        [hooksGroup]: [...state[hooksGroup], hookFunc],
      }))
    }

    callHooksFor = action => async () => {
      const hooksGroup = this.getHooksGroupName(action)
      return Promise.all(this.state[hooksGroup].map(hook => hook()))
    }

    addCancelHook = this.addHookOn(ACTIONS.CANCEL)
    addSubmitHook = this.addHookOn(ACTIONS.SUBMIT)
    addSuccessHook = this.addHookOn(ACTIONS.SUCCESS)

    callCancelHooks = this.callHooksFor(ACTIONS.CANCEL)
    callSubmitHooks = this.callHooksFor(ACTIONS.SUBMIT)
    callSuccessHooks = this.callHooksFor(ACTIONS.SUCCESS)

    render() {
      const hooksProps = {
        addCancelHook: this.addCancelHook,
        addSubmitHook: this.addSubmitHook,
        addSuccessHook: this.addSuccessHook,
        callCancelHooks: this.callCancelHooks,
        callSubmitHooks: this.callSubmitHooks,
        callSuccessHooks: this.callSuccessHooks,
      }

      return <WrappedComponent {...this.props} {...hooksProps} />
    }
  }

export default withHooks
